import { filtersObjectFromUrl } from '@common/utils/search-url-generator';

import { DEFAULT_FILTERS } from '../constants';

import { getSortingName } from './sorting';

export const adaptFilters = (filters, sortingAlgorithm) => {
  const sortBy = getSortingName(filters.sortBy, sortingAlgorithm);

  return {
    bathrooms: filters['bathrooms[]'],
    bed: filters.bed,
    budget: filters.budget,
    features: filters['features[]'],
    moveIn: filters['move-in'],
    moveOut: filters['move-out'],
    flexibleMoveIn: parseInt(filters.flexibleMoveIn, 10),
    flexibleMoveOut: parseInt(filters.flexibleMoveOut, 10),
    topology: filters['topology[]'],
    type: filters['type[]'],
    page: filters.page,
    noDeposit: filters.noDeposit,
    instantBooking: filters.instantBooking,
    superLister: filters.superLister,
    ids: filters['ids[]'],
    sortBy,
    poiLat: filters.poiLat && parseFloat(filters.poiLat),
    poiLng: filters.poiLng && parseFloat(filters.poiLng),
    verified: filters.verified,
    areaId: filters['areaId[]']
  };
};

export const adaptFiltersToUrl = (filters, sortingAlgorithm) => {
  const sortBy = getSortingName(filters.sortBy, sortingAlgorithm);

  return { ...filters, sortBy };
};

export const getInitialFilters = (originalUrl, areaInfo) => ({
  ...DEFAULT_FILTERS,
  ...filtersObjectFromUrl(originalUrl, areaInfo)
});

export const getDefaultFilters = () => DEFAULT_FILTERS;

export default {
  adaptFilters,
  adaptFiltersToUrl,
  getInitialFilters,
  getDefaultFilters
};
